/**
 * Get cookie data.
 * @param {String} name
 * @returns {String|Null}|
 */

if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.authorization_token;
      this.applyBtn = this.querySelector('#apply-discount-btn');
      this.discountCodeError = this.querySelector('#discount-code-error');
      this.discountCodeInput = this.querySelector('#discount-code-input');
      this.discountCodeNote = this.querySelector('.discount-code__note');

      this.applyBtn.addEventListener(
        'click',
        this.handleDiscountCodeAdd.bind(this),
      );
      this.discountCodeInput.addEventListener(
        'keypress',
        this.handleKeyPress.bind(this),
      );

      if (getCookie('discount_code')) {
        document
          .querySelectorAll(
            'button[name="checkout"], .additional-checkout-buttons',
          )
          .forEach((button) => {
            button.removeAttribute('disabled');
          });
      }
    }

    handleKeyPress(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        this.handleDiscountCodeAdd(e);
      }
    }

    handleDiscountCodeAdd(e) {
      e.preventDefault();

      let checkoutContainer = document.createElement('div');
      document.body.appendChild(checkoutContainer);

      this.applyDiscount(this.discountCodeInput.value);
    }

    applyDiscount(code) {
      if (this.applyBtn) {
        this.applyBtn.innerHTML = 'APPLYING';
        this.applyBtn.style.pointerEvents = 'none';
      }

      fetch('/payments/config', { method: 'GET' })
        .then((response) => response.json())
        .then((data) => {
          const checkout_json_url = '/wallets/checkouts/';
          this.authorization_token = btoa(data.paymentInstruments.accessToken);

          fetch('/cart.js', {})
            .then((res) => res.json())
            .then((data) => {
              let body = {
                checkout: {
                  country: Shopify.country,
                  discount_code: code,
                  line_items: data.items,
                  presentment_currency: Shopify.currency.active,
                },
              };

              fetch(checkout_json_url, {
                headers: {
                  'accept': '*/*',
                  'cache-control': 'no-cache',
                  'authorization': 'Basic ' + this.authorization_token,
                  'content-type': 'application/json, text/javascript',
                  'pragma': 'no-cache',
                  'sec-fetch-dest': 'empty',
                  'sec-fetch-mode': 'cors',
                  'sec-fetch-site': 'same-origin',
                },
                referrerPolicy: 'strict-origin-when-cross-origin',
                method: 'POST',
                mode: 'cors',
                credentials: 'include',
                body: JSON.stringify(body),
              })
                .then((response) => response.json())
                .then((data) => {
                  if (
                    data.checkout &&
                    data.checkout.applied_discounts.length > 0
                  ) {
                    const discountApplyUrl = `/discount/${code}?v=${Date.now()}&redirect=/checkout/`;

                    fetch(discountApplyUrl, {});

                    if (this.discountCodeError) {
                      this.discountCodeError.innerHTML = '';
                    }

                    document
                      .querySelectorAll(
                        'button[name="checkout"], .additional-checkout-buttons',
                      )
                      .forEach((button) => {
                        button.removeAttribute('disabled');
                      });

                    // Add code to cart note and reset the input
                    this.discountCodeNote.value = code;
                    this.discountCodeInput.value = '';

                    // Timeout is required to let the server update the discount codes.
                    setTimeout(() => {
                      this.closest('[data-cart-main]')
                        .querySelector('cart-items')
                        .updateCartSection();
                    }, 500);
                  } else {
                    if (this.discountCodeError)
                      this.discountCodeError.innerHTML =
                        'The code is invalid, contact us for more information.';
                  }
                })
                .finally(() => {
                  if (this.applyBtn) {
                    this.applyBtn.innerHTML = 'APPLY';
                    this.applyBtn.style.pointerEvents = 'all';
                  }
                });
            });
        });
    }
  }
  customElements.define('discount-code', DiscountCode);
}
